import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=44bd38a6&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"
import style0 from "./Index.vue?vue&type=style&index=0&id=44bd38a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bd38a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44bd38a6')) {
      api.createRecord('44bd38a6', component.options)
    } else {
      api.reload('44bd38a6', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=44bd38a6&scoped=true&", function () {
      api.rerender('44bd38a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Client/Index.vue"
export default component.exports